<template>
<div>
    <div class="get-started w50 p-5">
        <div class="w100">
            <h1>Get<br>started</h1>
            <p class="mt-3">Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book</p>
        </div>
    </div>
    <div class="registration-form-ec">
        <div class="form-wrap  row align-items-center"> <a href="" class="back-btn"><i class="fas fa-arrow-left"></i></a>
            <div class="bg_white form-box">
                <!-- <img src="<?=base_url()?>/assets/images/egurushala.png" width=300px alt="Egurushala ERP Solutions"> -->
                <div class="login-head">
                    <h2 class="text-center">Please enter the OTP sent to <span>{{mobile}}</span></h2>
                    <p class="text-center">Please enter OTP to verfiy your account</p>
                </div>
                <form id="otp_form" class=" w100 mt-2 " autocomplete="off">
                    <!-- <label for="otp">Enter OTP</label> -->
                    <!-- <v-otp-input
  length="4" tabindex="1" v-model="otp" name="otp" required=""
></v-otp-input> -->
                    <input type="number" maxlength="6" tabindex="1" v-model="otp" name="otp" required="" class="w100" id="otp" />
                    <div class="mt-3 form-control-wrapper">
                        <input type="button" @click="submitOtp()" value="Verify OTP" class="text-center form-btn">
                    </div>
                </form>
                <p class="text-center mt-4 form-control-wrapper">Didn't receive the verification OTP? <a href="#">Resend Again</a> <!-- <a href="<?= base_url() ?>admin/dashboard">Admin</a> -->
                </p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
import ApiList from '../ApiList'
export default {
    components: {},
    name: 'verifyOtp',
    mixins: [ApiList],
    data() {
        return {
            mobile: '',
            otp: ''
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.mobile = localStorage.getItem("tmp_mobile")
            this.name = localStorage.getItem("name");
            this.referral_code = localStorage.getItem("referral_code");
        },

        chooseStore() {
            // check no of stores User registered with   
            this.newUrl = this.apis.apiUrl + this.apis.chooseStoreUrl;
            this.param = {
                params: {
                    token: this.apis.token,
                    db: localStorage.selected_db,
                }
            }
            console.log("i m  in choose store")
            axios.get(this.newUrl, this.param)
                .then((response) => {
                    localStorage.setItem('store_id', response.data.store_id);
                    localStorage.setItem('token', response.data.token);
                    this.$router.push('/home');
                    console.log("response data details ::   " + JSON.stringify(response.data))

                });

        },
        submitOtp() {

            if (localStorage.selected_db === null || localStorage.selected_db === undefined) {
                // console.log("1111")
                this.newUrl = this.apis.apiUrl + this.apis.verifyMobile;
                this.param = {
                    params: {
                        token: this.apis.token,
                        // token: localStorage.getItem("token"),
                        mobile: this.mobile,
                        otp: this.otp,
                    }
                }

            } else {
                //  console.log("11112222222")
                var myToken = ""

                if (localStorage.getItem("token") == null) {
                    myToken = this.apis.token
                } else {
                    myToken = localStorage.token
                }

                if (this.referral_code != null) {
                    this.newUrl = this.apis.apiUrl + this.apis.verifyUrl;
                    this.param = {
                        params: {
                            token: myToken, //localStorage.token,
                            mobile: this.mobile,
                            otp: this.otp,
                            name: this.name,
                            referral_code: this.referral_code
                        }
                    }
                } else {
                    console.log("without reffral code")
                    this.newUrl = this.apis.apiUrl + this.apis.verifyUrl;
                    this.param = {
                        params: {
                            token: myToken, //localStorage.token,
                            mobile: this.mobile,
                            otp: this.otp,
                            name: this.name
                        }
                    }
                }
            }
            // alert(this.newUrl)
            axios.get(this.newUrl, this.param)
                .then((response) => {
                    console.log("verifyOTP  :  " + JSON.stringify(response.data))
                    if (response.data.status == 0) {
                        localStorage.setItem("customer_id", response.data.cust_id);
                        localStorage.setItem("name", response.data.name);
                        localStorage.setItem("customer_id", response.data.cust_id);
                        localStorage.setItem("mobile", response.data.mobile);
                        localStorage.setItem("loginStatus", true);

                        // fetch store in which user Registered
                        this.customer_id = localStorage.customer_id
                        this.newUrl = this.apis.apiUrl + this.apis.checkUserStores;
                        this.param = {
                            params: {
                                token: this.apis.token,
                                customer_id: this.customer_id
                            }
                        }
                        axios.get(this.newUrl, this.param)
                            .then((response) => {
                                var storeList = response.data
                                console.log("store List" + JSON.stringify(storeList))
                                localStorage.setItem("noOfStores", storeList.length)
                                if (storeList.length == 1) {
                                    console.log("single store - " + storeList.length)

                                    localStorage.setItem('store_name', response.data[0].store_name);
                                    localStorage.setItem('selected_db', response.data[0].database_name);

                                    this.chooseStore()
                                } else // (localStorage.getItem('noOfStores') > 1) 
                                {
                                    this.$router.push('/storeSelect');
                                }
                            });

                    } else {
                        alert("Invalid OTP");
                    }
                });
        }

    },
}
</script>
